import { cloned } from '@/helpers'
import APICONF from '@/api/config' // use this to avoid recursive imports
// import Device from '@/models'

const _EMPTY = {
  email: '',
  password: '',
  device: '',
  authorization: null,
  authorized: null
}

export const Session = {

  empty () {
    return cloned(_EMPTY)
  },
  
  import (o) {
    let oi = this.empty()
    oi.authorization = o.Authorization 
    oi.authorized = JSON.stringify({ 
      id: o.user.id, 
      account_id: o.user.account_id,
      device: "0000-0000-0000",
      timestamp: 0
    })
    return oi
  },

  export (o) {
    // Export the required API object
    return {
      email: o.email,
      password: o.password,
      device: 'N/A' // Device.uid()
    }
  },

  isActive() {
    /**
     * The session is Active,
     * the user is logged in,
     * and the API token is available.
     */
    return (APICONF.token() != null)
  },

  isLocked() {
    /**
     * This session is Locked by the user,
     * must input user password to open it.
     */ 
    // NOT available yet
    return false
  },

  lock() {
    /**
     * Locks the session. 
     */
  },

  login(user, password, extras) {
    /**
     * Login using the API.
     * 
     * @user: email of user
     * @password: the user password
     * @extras: indicates if additional options
     * 
     * After login it saves the API token and 
     * sets the session as Active.
     */
  },

  logout() {
    /**
     * Logs out, reseting the API token 
     * and setting the session as Inactive.
     */
    APICONF.reset() 
  },

  save() {
    APICONF.saveState()
  },

  restore() {
    APICONF.restoreState()
  }
}
